
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.062 1.836c.525-.443 1.372-.443 1.882 0l1.185 1.012c.225.188.653.345.953.345h1.275c.795 0 1.447.653 1.447 1.448v1.275c0 .3.158.72.345.945l1.013 1.185c.442.525.442 1.372 0 1.882l-1.013 1.185a1.71 1.71 0 00-.345.945v1.275c0 .795-.652 1.448-1.447 1.448h-1.275c-.3 0-.72.157-.945.345l-1.185 1.012c-.525.443-1.373.443-1.883 0l-1.185-1.012a1.73 1.73 0 00-.945-.345H4.627a1.453 1.453 0 01-1.448-1.448v-1.282c0-.293-.15-.72-.337-.938L1.829 9.921c-.435-.518-.435-1.358 0-1.875l1.013-1.193c.187-.225.337-.645.337-.937V4.648c0-.795.653-1.447 1.448-1.447h1.297c.3 0 .72-.158.945-.345l1.193-1.02zM9.001 6.098V9.72","stroke":"#515952","stroke-width":"1.295","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.996 12h.007","stroke":"#515952","stroke-width":"1.727","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    